import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
}

export default new Vuex.Store({
  state: {
    site: [],
    home: [],
    projectsPage: [],
    projects: [],
    project: [],
    defaultPage: [],
    contact: [],
    about: [],
    clients: [],
    error: [],
  },
  getters: {
    getProjectByUID: (state) => (uid, collection = state.projects) => {
      let i = collection.length
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i]
        }
      }
    },
    getProjectsByUID: (state) => (uids, collection = state.projects) => {
      let i = uids.length, matchedProjects = [];
      while (i--) {
        matchedProjects.push(collection.find(project => project.uid === uids[i]));
      }
      return matchedProjects
    }
  },
  actions: {
    async loadSite ({ commit }) {
      await axios.post('/api/query', {
        "query": "site",
        "select": {
          "title": true,
          "url": true,
          "analyticsId":"site.analyticsId",
          "seoImage": "site.seoImage.toFile.url",
          "logo_light":"site.logo_light.toFile.url",
          "logo_dark":"site.logo_dark.toFile.url",
          "en": {
            "query" : "site.content('en')",
            "select": {
              "seoDescription":"content.seoDescription",
            }
          },
          "fr": {
            "query" : "site.content('fr')",
            "select": {
              "seoDescription":"content.seoDescription",
            }
          },
          "langs": "kirby.languages"
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_SITE', response.data.result)
      })
    },
    async loadProjectsPage ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('projects')",
        "select": {
          "title": true,
          "uid": true,
          "en":{
            "query": "page.content",
            "select": {
              "title": "content.title", 
              "mainTitle": "content.mainTitle", 
              "description": "content.description.kirbytext",
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "title": "content.title", 
              "mainTitle": "content.mainTitle", 
              "description": "content.description.kirbytext",
            }
          },
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_PROJECTS_PAGE', response.data.result)
      })
    },
    async loadProjects ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('projects').children",
        "select": {
          "title": true,
          "uid": true,
          "id": true,
          "year": true,
          "status": 'page.status',
          "category": true,
          "en":{
            "query": "page.content('en')",
            "select": {
              "title": "content.title",
              "mainDescription": "content.mainDescription.kirbytext",
              "description": "content.description.kirbytext",
              "additionalInformations": "content.additionalInformations.kirbytext",
              "mainContent": "content.mainContent",
              "thumbCover": {
                "query": "content.thumbCover.toFile",
                "select": {
                  "srcset": "file.srcset(default)",
                  "thumb": "file.thumb.url",
                  "url": "file.url",
                  "filename": "file.filename",
                  "extension": "file.extension",
                }
              },
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "title": "content.title",
              "mainDescription": "content.mainDescription.kirbytext",
              "description": "content.description.kirbytext",
              "additionalInformations": "content.additionalInformations.kirbytext",
              "mainContent": "content.mainContent",
              "thumbCover": {
                "query": "content.thumbCover.toFile",
                "select": {
                  "srcset": "file.srcset(default)",
                  "thumb": "file.thumb.url",
                  "url": "file.url",
                  "filename": "file.filename",
                  "extension": "file.extension",
                }
              },
            }
          },
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_PROJECTS', response.data.result.data)
      })
    },
    async loadProject ({ commit }, uid) {
      await axios.post('/api/query', {
        "query": "page('projects/"+uid+"')",
        "select": {
          "title": true,
          "uid": true,
          "id": true,
          "year": true,
          "status": 'page.status',
          "category": true,
          "en":{
            "query": "page.content('en')",
            "select": {
              "headerColor": "content.headercolor",
              "title": "content.title",
              "mainDescription": "content.mainDescription.kirbytext",
              "description": "content.description.kirbytext",
              "mainContent": "content.mainContent",
              "linkedProjects":{
                "query": "content.linkedProjects.toPages",
                "select": {
                  "uid": "page.uid",
                  "title": "page.content('en').title",
                  "additionalInformations": "page.content('en').additionalInformations",
                  "thumbCover": {
                    "query": "page.content('en').thumbCover.toFile",
                    "select": {
                      "srcset": "file.srcset",
                      "url": "file.url",
                      "thumb": "file.thumb",
                      "filename": "file.filename",
                      "alt": "file.alt",
                      "extension": "file.extension",
                    }
                  },
                }
              }
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "headerColor": "content.headercolor",
              "title": "content.title",
              "mainDescription": "content.mainDescription.kirbytext",
              "description": "content.description.kirbytext",
              "mainContent": "content.mainContent",
              "linkedProjects":{
                "query": "content.linkedProjects.toPages",
                "select": {
                  "uid": "page.uid",
                  "title": "page.content('fr').title",
                  "additionalInformations": "page.content('fr').additionalInformations",
                  "thumbCover": {
                    "query": "page.content('fr').thumbCover.toFile",
                    "select": {
                      "srcset": "file.srcset",
                      "url": "file.url",
                      "thumb": "file.thumb",
                      "filename": "file.filename",
                      "alt": "file.alt",
                       "extension": "file.extension",
                    }
                  },
                }
              }
            }
          },
          "images": {
            "query": "page.images",
            "select": {
              "url": "file.thumb.url",
              "thumb": "file.resize(200).url",
              "filename": "file.filename",
              "srcset": "file.srcset(default)",
            }
          },

        }
      }, { auth }
      ).then(function(response) {
        commit('SET_PROJECT', response.data.result)
      })
    },
    async loadHome ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('home')",
        "select": {
          "title": true,
          "uid": true,
          "mainDescription" : {
            "query": "site",
            "select": {
              "catchline": "site.mainDescription.kirbyText"
            }
          },
          "en":{
            "query": "page.content('en')",
            "select": {
              "title": "content.title", 
              "expertiseDescription": "content.expertiseDescription.kirbytext",
              "expertiseSections": 'content.expertiseSections.yaml',
              "faq": "content.faq.yaml",
              "mainDescription": "site.content('en').mainDescription.kirbyText",
              "buttonText": "content.buttonText",
              "diaporama": {
                "query": "site.content('en').diaporama.toStructure",
                "select" : {
                  'bgcolor': 'structureItem.bgcolor',
                  'dotcolor': 'structureItem.dotcolor',
                  'template': 'structureItem.template',
                  'project': {
                    "query": 'structureItem.project.toPage',
                    "select":{
                      "title":"page.content('en').title",
                      "uid":"page.uid",
                      'sliderInfos': "page.content('en').sliderinformations",
                      'sliderCover': {
                        'query' : "page.content('en').sliderCover.toFile",
                        'select' : {
                          "url": "file.thumb.url",
                          "alt": "file.alt",
                          "filename": "file.filename",
                          "srcset": "file.srcset(default)",
                        }
                      }
                    }
                  }
                }
              },
               "thumbprojects": {
                "query": "site.content('en').thumbprojects.toPages",
                "select" : {
                  "uid": "page.uid",
                  "title": "page.content('en').title",
                  "status" : "page.status",
                  "additionalInformations": "page.content('en').additionalInformations",
                  "thumbCover": {
                    "query": "page.content('en').thumbCover.toFile",
                    "select": {
                      "srcset": "file.srcset",
                      "url": "file.url",
                      "thumb": "file.thumb",
                      "filename": "file.filename",
                      "alt": "file.alt",
                       "extension": "file.extension",
                    }
                  }
                }
              },
              "testimonialsTitle": "content.testimonialstitle",
              "testimonials": {
                "query": "content.testimonials.toStructure",
                "select" : {
                  "companyLogo":{
                    "query": "structureItem.companyLogo.toFile",
                    "select" : {
                      "url": "file.url",
                      "thumb": "file.resize(300).url",
                      "filename": "file.filename",
                      "srcset": "file.srcset(default)",
                    }
                  },
                  "clientPicture":{
                    "query": "structureItem.clientPicture.toFile",
                    "select" : {
                      "url": "file.url",
                      "thumb": "file.resize(300).url",
                      "filename": "file.filename",
                      "srcset": "file.srcset(default)",
                    }
                  }, 
                  "postType": "structureItem.postType",
                  "bgColor": "structureItem.bgColor",
                  "colorLogo": "structureItem.colorLogo.value",
                  "textColor": "structureItem.textColor",
                  "url": "structureItem.url",
                  "text": "structureItem.testimonial.kirbytext",
                  "clientName": "structureItem.clientName",
                  "clientDescription": "structureItem.clientDescription.kirbytext",
                }
              }
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "title": "content.title", 
              "expertiseDescription": "content.expertiseDescription.kirbytext",
              "expertiseSections": 'content.expertiseSections.yaml',
              "faq": "content.faq.yaml",
              "mainDescription": "site.content('fr').mainDescription.kirbyText",
              "buttonText": "content.buttonText",
              "diaporama": {
                "query": "site.content('fr').diaporama.toStructure",
                "select" : {
                  'bgcolor': 'structureItem.bgcolor',
                  'dotcolor': 'structureItem.dotcolor',
                  'template': 'structureItem.template',
                  'project': {
                    "query": 'structureItem.project.toPage',
                    "select":{
                      "title":"page.content('fr').title",
                      "uid":"page.uid",
                      'sliderInfos': "page.content('fr').sliderinformations",
                      'sliderCover': {
                        'query' : "page.content('fr').sliderCover.toFile",
                        'select' : {
                          "url": "file.thumb.url",
                          "alt": "file.alt",
                          "filename": "file.filename",
                          "srcset": "file.srcset(default)",
                        }
                      }
                    }
                  }
                }
              },
              "thumbprojects": {
                "query": "site.content('fr').thumbprojects.toPages",
                "select" : {
                  "uid": "page.uid",
                  "title": "page.content('fr').title",
                  "status" : "page.status",
                  "additionalInformations": "page.content('fr').additionalInformations",
                  "thumbCover": {
                    "query": "page.content('fr').thumbCover.toFile",
                    "select": {
                      "srcset": "file.srcset",
                      "url": "file.url",
                      "thumb": "file.thumb",
                      "filename": "file.filename",
                      "alt": "file.alt",
                       "extension": "file.extension",
                    }
                  }
                }
              },
              "testimonialsTitle": "content.testimonialstitle",
              "testimonials": {
                "query": "content.testimonials.toStructure",
                "select" : {
                  "companyLogo":{
                    "query": "structureItem.companyLogo.toFile",
                    "select" : {
                      "url": "file.url",
                      "thumb": "file.resize(300).url",
                      "filename": "file.filename",
                      "srcset": "file.srcset(default)",
                    }
                  },
                  "clientPicture":{
                    "query": "structureItem.clientPicture.toFile",
                    "select" : {
                      "url": "file.url",
                      "thumb": "file.resize(300).url",
                      "filename": "file.filename",
                      "srcset": "file.srcset(default)",
                    }
                  }, 
                  "postType": "structureItem.postType",
                  "bgColor": "structureItem.bgColor",
                  "colorLogo": "structureItem.colorLogo.value",
                  "textColor": "structureItem.textColor",
                  "url": "structureItem.url",
                  "text": "structureItem.testimonial.kirbytext",
                  "clientName": "structureItem.clientName",
                  "clientDescription": "structureItem.clientDescription.kirbytext",
                }
              }
            }
          },
          "images": {
            "query": "page.images",
            "select":{
              "url": "file.thumb.url",
              "thumb": "file.resize(200).url",
              "filename": "file.filename",
              "srcset": "file.srcset(default)",
            }
          },
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_HOME', response.data.result)
      })
    },
    async loadDefaultPage ({ commit}, uid) {
      await axios.post('/api/query', {
        "query": "page('"+uid.path+"')",
        "select": {
          "title": true,
          "uid": true,
          "en":{
            "query": "page.content('en')",
            "select": {
              "title": "content.title", 
              "text": "content.text.kirbytext"
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "title": "content.title", 
               "text": "content.text.kirbytext"
            }
          },
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_DEFAULTPAGE', response.data.result)
      })
    },
    async loadContact ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('contact')",
        "select": {
          "title": true,
          "uid": true,
          "mainText": "page.mainText.kirbytext",
          "address": "page.address.kirbytext",
          "socials": "page.socials.yaml",
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_CONTACT', response.data.result)
      })
    },
    async loadAbout ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('a-propos')",
        "select": {
          "title": true,
          "uid": true,
          "en":{
            "query": "page.content('en')",
            "select": {
              "title": "content.title", 
              "description": "content.description.kirbytext",
              "partnersTitle": "content.partnersTitle",
              "partners": "content.partners.kirbytext",
              "partnersLogos": {
                "query" : "content.partnersLogos.toStructure",
                "select":{
                  "name": "structureItem.name",
                  "logo": {
                    "query": "structureItem.logo.toFile",
                    "select": {
                     "url": "file.thumb.url",
                      "srcset": "file.srcset",
                      "alt": "file.alt",
                      "filename": "file.filename"
                    }
                  },
                  "class": "structureItem.class"
                } 
              },
              "servicesTitle": "content.servicesTitle",
              "services": {
                "query" : "content.services.toStructure",
                "select":{
                  "categorie": "structureItem.categorie",
                  "services": "structureItem.services.yaml",
                } 
              },
              "teamTitle": "content.teamTitle",
              "teamMembers": {
                "query" : "content.teamMembers.toStructure",
                "select":{
                  "name": "structureItem.name",
                  "job": "structureItem.job",
                  "description": "structureItem.description.kirbytext",
                  "portrait": {
                    "query": "structureItem.portrait.toFile",
                    "select": {
                      "url": "file.thumb.url",
                      "srcset": "file.srcset",
                      "alt": "file.alt",
                      "filename": "file.filename"
                    }
                  } 
                } 
              },
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "title": "content.title", 
              "description": "content.description.kirbytext",
              "partnersTitle": "content.partnersTitle",
              "partners": "content.partners.kirbytext",
              "partnersLogos": {
                "query" : "content.partnersLogos.toStructure",
                "select":{
                  "name": "structureItem.name",
                  "logo": {
                    "query": "structureItem.logo.toFile",
                    "select": {
                      "url": "file.thumb.url",
                      "srcset": "file.srcset",
                      "alt": "file.alt",
                      "filename": "file.filename"
                    }
                  },
                  "class": "structureItem.class"
                } 
              },
              "servicesTitle": "content.servicesTitle",
              "services": {
                "query" : "content.services.toStructure",
                "select":{
                  "categorie": "structureItem.categorie",
                  "services": "structureItem.services.yaml",
                } 
              },
              "teamTitle": "content.teamTitle",
              "teamMembers": {
                "query" : "content.teamMembers.toStructure",
                "select":{
                  "name": "structureItem.name",
                  "job": "structureItem.job",
                  "description": "structureItem.description.kirbytext",
                  "portrait": {
                    "query": "structureItem.portrait.toFile",
                    "select": {
                      "url": "file.thumb.url",
                      "srcset": "file.srcset",
                      "alt": "file.alt",
                      "filename": "file.filename"
                    }
                  } 
                } 
              },
            }
          },
          "images": {
            "query": "page.images",
            "select":{
              "url": "file.thumb.url",
              "thumb": "file.resize(200).url",
              "filename": "file.filename",
              "srcset": "file.srcset",
            }
          }
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_ABOUT', response.data.result)
      })
    },
    async loadClients ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('clients')",
        "select": {
          "title": true,
          "uid": true,
          "en":{
            "query": "page.content('en')",
            "select": {
              "title": "content.title", 
              "mainTitle": "content.mainTitle", 
              "description": "content.description.kirbytext",
              "catchline": "content.catchline.kirbytext",
              "clients": {
                "query" : "content.clients.toStructure",
                "select":{
                  "name": "structureItem.name",
                  "description": "structureItem.description.kirbytext"
                } 
              },
              // "testimonials": {
              //   "query" : "content.testimonials.toStructure",
              //   "select":{
              //     "testimonial": "structureItem.testimonial.kirbytext",
              //     "client": "structureItem.client.kirbytext",
              //   } 
              // },
              "testimonials": "content.testimonials.kirbytext",
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "title": "content.title", 
              "mainTitle": "content.mainTitle", 
              "description": "content.description.kirbytext",
              "catchline": "content.catchline.kirbytext",
              "clients": {
                "query" : "content.clients.toStructure",
                "select":{
                  "name": "structureItem.name",
                  "description": "structureItem.description.kirbytext"
                } 
              },
              // "testimonials": {
              //   "query" : "content.testimonials.toStructure",
              //   "select":{
              //     "text": "structureItem.text.kirbytext",
              //     "client": "structureItem.client.kirbytext",
              //   } 
              // },
              "testimonials": "content.testimonials.kirbytext",
            }
          },
          "images": {
            "query": "page.images",
            "select":{
              "url": "file.thumb.url",
              "thumb": "file.resize(200).url",
              "filename": "file.filename",
              "srcset": "file.srcset",
            }
          }
        }
      }, { auth }
      ).then(function(response) {
        commit('SET_CLIENTS', response.data.result)
      })
    },
    async loadError ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('error')",
        "select": {
          "title": true,
          "uid": true,
           "en":{
            "query": "page.content('en')",
            "select": {
              "title": "content.title", 
              "mainText": "content.mainText.kirbytext",
            }
          },
          "fr":{
            "query": "page.content('fr')",
            "select": {
              "title": "content.title", 
              "mainText": "content.mainText.kirbytext",
            }
          },
          "bgcolor": "page.bgcolor",

        }
      }, { auth }
      ).then(function(response) {
        commit('SET_ERROR', response.data.result)
      })
    },
  },
  mutations: {
    SET_SITE (state, site) {
      state.site = site
    },
    SET_HOME (state, pages) {
      state.home = pages
    },
    SET_PROJECTS_PAGE (state, pages) {
      state.projectsPage = pages
    },
    SET_PROJECTS (state, pages) {
      state.projects = pages
    },
    SET_PROJECT (state, page) {
      state.project = page
    },
    SET_DEFAULTPAGE (state, pages) {
      state.defaultPage = pages
    },
    SET_CONTACT (state, pages) {
      state.contact = pages
    },
    SET_ABOUT (state, pages) {
      state.about = pages
    },
    SET_CLIENTS (state, pages) {
      state.clients = pages
    },
    SET_ERROR (state, pages) {
      state.error = pages
    }
  }
})
